import { replace } from 'react-router-redux';

export const CREATE_ANSWER = 'CREATE_ANSWER';
export const UPDATE_ANSWER = 'UPDATE_ANSWER';
export const MOVE_ANSWER_UP = 'MOVE_ANSWER_UP';
export const MOVE_ANSWER_DOWN = 'MOVE_ANSWER_DOWN';
export const DELETE_ANSWER = 'DELETE_ANSWER';

function answerCreated(question, fields) {
  return {
    type: CREATE_ANSWER,
    payload: {
      question,
      fields,
    },
  };
}

function answerUpdated(id, answer) {
  return {
    type: UPDATE_ANSWER,
    payload: {
      id,
      answer,
    },
  };
}

export function createAnswer(question, fields) {
  return dispatch => {
    dispatch(answerCreated(question, fields));
    // Redirecting to questions list
    dispatch(replace('/questions'));
  };
}

export function updateAnswer(id, answer) {
  return dispatch => {
    dispatch(answerUpdated(id, answer));
    // Redirecting to questions list
    dispatch(replace('/questions'));
  };
}

export function moveAnswerUp(answer) {
  return {
    type: MOVE_ANSWER_UP,
    payload: {
      answer,
    },
  };
}

export function moveAnswerDown(answer) {
  return {
    type: MOVE_ANSWER_DOWN,
    payload: {
      answer,
    },
  };
}

export function deleteAnswer(answer) {
  return {
    type: DELETE_ANSWER,
    payload: {
      answer,
    },
  };
}



// WEBPACK FOOTER //
// ./src/modules/funnel/actions/answer.js